/* ============================================================
   Luca & Luce 2.0 — global behavior
   Ett delt system: header-tone, reveals, drift, overlays,
   søk, handlekurv, produktskjema, accordions, sideoverganger.

   All interaksjon bruker event-delegering på document, og
   initialisering kan rekjøres per seksjon. Dermed overlever
   alt Theme Editorens seksjons-rerendring
   (shopify:section:load) uten tap av tekst eller bindinger.
   ============================================================ */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  var routes = window.LucaRoutes || {};
  var strings = window.LucaStrings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var frac = parts[1];
    var out = frac === '00' ? whole : whole + ',' + frac;
    return out + ' kr';
  }

  /* ---------- Scroll lock ---------- */
  var lockCount = 0;
  function lockScroll(on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    var locked = lockCount > 0;
    docEl.classList.toggle('no-scroll', locked);
    document.body.classList.toggle('no-scroll', locked);
  }

  /* ---------- Focus trap ---------- */
  function trapFocus(container) {
    function focusables() {
      return $$('a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])', container)
        .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    }
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var els = focusables();
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* ---------- Overlay manager (element slås opp ved hver bruk,
       så en rerendret seksjon aldri gir stale referanser) ---------- */
  function Overlay(selector, opts) {
    opts = opts || {};
    var openState = false;
    var releaseTrap = null;
    var lastFocus = null;
    var api = {
      el: function () { return $(selector); },
      isOpen: function () { return openState; },
      open: function () {
        var el = api.el();
        if (!el || openState) return;
        openState = true;
        lastFocus = document.activeElement;
        el.classList.add('is-open');
        el.removeAttribute('aria-hidden');
        lockScroll(true);
        releaseTrap = trapFocus(el);
        var target = opts.focus ? $(opts.focus, el) : $('button, a, input', el);
        window.setTimeout(function () { if (target) target.focus(); }, reduced ? 0 : 280);
        if (opts.onOpen) opts.onOpen();
      },
      close: function () {
        var el = api.el();
        if (!el || !openState) return;
        openState = false;
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
        lockScroll(false);
        if (releaseTrap) { releaseTrap(); releaseTrap = null; }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        if (opts.onClose) opts.onClose();
      },
      toggle: function () { openState ? api.close() : api.open(); }
    };
    return api;
  }

  var overlays = {
    menu: Overlay('[data-ll-menu]', { focus: '[data-overlay-close]' }),
    search: Overlay('[data-ll-search]', { focus: '[data-search-input]' }),
    cart: Overlay('[data-ll-cart]', { focus: '[data-overlay-close]' }),
    /* Land- og språkvelger: fokus lander på valgt land, ikke på «Lukk» */
    locale: Overlay('[data-ll-locale]', { focus: '.ll-locale__row.is-active' })
  };

  function closeAllOverlays(except) {
    Object.keys(overlays).forEach(function (k) {
      if (overlays[k] !== except) overlays[k].close();
    });
  }

  /* ---------- Header tone + progressiv bakgrunn ---------- */
  function applyHeader() {
    var header = $('[data-ll-header]');
    if (!header) return;
    var y = window.scrollY || 0;
    var rect = header.getBoundingClientRect();
    var probe = rect.top + rect.height * 0.55;
    var tone = 'dark';
    var marks = $$('[data-header-tone="light"]');
    for (var i = 0; i < marks.length; i++) {
      var r = marks[i].getBoundingClientRect();
      if (r.width > 60 && r.top <= probe && r.bottom >= probe) { tone = 'light'; break; }
    }
    var prog = Math.max(0, Math.min(1, (y - 4) / 88));
    var alpha = tone === 'light' ? 0 : prog;
    header.style.backgroundColor = 'rgba(242,239,231,' + alpha.toFixed(3) + ')';
    header.style.borderColor = 'rgba(20,20,18,' + (alpha * 0.14).toFixed(3) + ')';
    header.classList.toggle('is-light', tone === 'light');
    if (window.innerWidth > 767) {
      header.style.height = (92 - 20 * prog).toFixed(1) + 'px';
    } else {
      header.style.height = '';
    }
  }

  /* ---------- Parallax / drift (referanser slås opp på nytt
       ved hver seksjons-rerendring) ---------- */
  var hero = null, heroText = null, drifts = [];
  function refreshMotionRefs() {
    hero = $('[data-hero-img]');
    heroText = $('[data-hero-text]');
    drifts = $$('[data-drift]');
  }
  function applyMotion() {
    if (reduced) return;
    var y = window.scrollY || 0;
    if (hero) {
      var p = Math.min(y, 900);
      hero.style.transform = 'translate3d(0,' + (p * 0.12).toFixed(2) + 'px,0) scale(' + (1 + Math.min(p / 900, 1) * 0.03).toFixed(4) + ')';
    }
    if (heroText && !designMode) {
      heroText.style.opacity = String(Math.max(0, 1 - y / 420));
      heroText.style.transform = 'translate3d(0,' + (y * -0.05).toFixed(2) + 'px,0)';
    }
    var vh = window.innerHeight;
    drifts.forEach(function (img) {
      var r = img.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var mid = r.top + r.height / 2 - vh / 2;
      var shift = Math.max(-28, Math.min(28, -mid * 0.035));
      img.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      applyHeader();
      applyMotion();
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- Scroll reveals (rekjørbar per scope) ---------- */
  var revealObserver = null;
  function initReveals(scope) {
    var els = $$('[data-reveal]', scope);
    if (!els.length) return;
    if (reduced || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
          el.style.transitionDelay = delay ? delay + 'ms' : '';
          el.classList.add('is-revealed');
          revealObserver.unobserve(el);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
    }
    els.forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) {
        var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
        el.style.transitionDelay = delay ? delay + 'ms' : '';
        el.classList.add('is-revealed');
      } else {
        revealObserver.observe(el);
      }
    });
    /* Sikkerhetsnett: innhold skal aldri forbli skjult */
    window.setTimeout(function () {
      $$('[data-reveal]:not(.is-revealed)', scope).forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > -40) el.classList.add('is-revealed');
      });
    }, 1200);
  }

  /* ---------- Handlekurv ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }
  function replaceCartDrawer(html) {
    var drawer = $('[data-ll-cart]');
    if (!drawer || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var next = $('[data-cart-inner]', tmp);
    var current = $('[data-cart-inner]', drawer);
    if (next && current) {
      current.innerHTML = next.innerHTML;
      if (overlays.cart.isOpen() && drawer.contains(document.activeElement) === false) {
        var closeBtn = $('[data-overlay-close]', drawer);
        if (closeBtn && closeBtn.focus) closeBtn.focus();
      }
    }
    var countEl = $('[data-cart-count-source]', tmp);
    if (countEl) updateCartCount(countEl.textContent.trim());
  }
  function refreshCart() {
    return fetch((routes.root || '/') + '?section_id=ll-cart-drawer')
      .then(function (r) { return r.text(); })
      .then(replaceCartDrawer)
      .catch(function () {});
  }
  function cartChange(key, quantity) {
    return fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cartData) {
      updateCartCount(cartData.item_count);
      return refreshCart();
    });
  }
  function addToCart(formData) {
    return fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      return fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cartData) { updateCartCount(cartData.item_count); });
    }).then(refreshCart);
  }

  /* ---------- Produktskjema ---------- */
  function handleProductSubmit(form) {
    var submit = $('[data-add-button]', form);
    if (submit && (submit.disabled || submit.getAttribute('aria-disabled') === 'true')) return;
    if (form.dataset.adding === '1') return; // vern mot dobbeltklikk/raske gjentatte klikk
    form.dataset.adding = '1';
    var label = submit ? $('[data-add-label]', submit) || submit : null;
    var original = label ? label.textContent : '';
    if (label) label.textContent = strings.adding || 'Legger til …';
    addToCart(new FormData(form)).then(function () {
      delete form.dataset.adding;
      if (label) label.textContent = strings.added || 'Lagt i handlekurv';
      window.setTimeout(function () { if (label) label.textContent = original; }, 1800);
      window.setTimeout(function () { overlays.cart.open(); }, 200);
    }).catch(function (err) {
      delete form.dataset.adding;
      if (label) label.textContent = original;
      var status = $('[data-form-status]', form.closest('[data-product-info]') || form);
      if (status) {
        status.hidden = false;
        status.textContent = (err && err.description) || strings.cart_error || 'Noe gikk galt. Prøv igjen.';
      }
    });
  }

  /* ---------- Variantvalg (flervariant-produkter) ---------- */
  function variantData(info) {
    var dataEl = $('[data-variant-json]', info);
    if (!dataEl) return null;
    try { return JSON.parse(dataEl.textContent); } catch (e) { return null; }
  }
  function selectedOptions(info) {
    var opts = [];
    $$('[data-option-index]', info).forEach(function (group) {
      var active = $('.is-active', group);
      opts[parseInt(group.getAttribute('data-option-index'), 10)] = active ? active.getAttribute('data-option-value') : null;
    });
    return opts;
  }
  function applyVariant(info, variant) {
    var form = $('form[data-product-form]', info);
    var idInput = form ? $('input[name="id"]', form) : null;
    var priceEl = $('[data-product-price]', info);
    var button = $('[data-add-button]', info);
    var labelEl = button ? ($('[data-add-label]', button) || button) : null;
    if (!variant) {
      if (button) button.disabled = true;
      if (labelEl) labelEl.textContent = strings.unavailable || 'Utilgjengelig';
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    var presale = info.getAttribute('data-presale') === 'true';
    if (button && labelEl) {
      if (variant.available) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        labelEl.textContent = presale ? (strings.preorder || 'Forhåndsbestill') : (strings.add_to_cart || 'Legg i handlekurv');
      } else {
        button.disabled = true;
        labelEl.textContent = strings.sold_out || 'Utsolgt';
      }
    }
    if (history.replaceState && variant.id) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  /* ---------- Global klikk-delegering ----------
     Alt overlever DOM-utskifting fra Theme Editor og cart-refresh. */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var opener = t.closest && t.closest('[data-open]');
    if (opener) {
      var target = overlays[opener.getAttribute('data-open')];
      if (target && target.el()) {
        e.preventDefault();
        closeAllOverlays(target);
        target.open();
        return;
      }
    }

    var closer = t.closest && t.closest('[data-overlay-close]');
    if (closer) {
      Object.keys(overlays).forEach(function (k) {
        var el = overlays[k].el();
        if (el && el.contains(closer)) overlays[k].close();
      });
      return;
    }

    var accBtn = t.closest && t.closest('.ll-acc__btn');
    if (accBtn) {
      var item = accBtn.closest('.ll-acc__item');
      var group = accBtn.closest('[data-accordion]');
      if (item && group) {
        var isOpen = item.classList.contains('is-open');
        if (group.getAttribute('data-accordion') !== 'multi') {
          $$('.ll-acc__item.is-open', group).forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var b = $('.ll-acc__btn', other);
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !isOpen);
        accBtn.setAttribute('aria-expanded', String(!isOpen));
      }
      return;
    }

    var qtyBtn = t.closest && t.closest('[data-qty-change]');
    if (qtyBtn) {
      qtyBtn.disabled = true;
      cartChange(qtyBtn.getAttribute('data-key'), parseInt(qtyBtn.getAttribute('data-qty'), 10));
      return;
    }
    var removeBtn = t.closest && t.closest('[data-line-remove]');
    if (removeBtn) {
      removeBtn.disabled = true;
      cartChange(removeBtn.getAttribute('data-key'), 0);
      return;
    }

    var pill = t.closest && t.closest('[data-option-value]');
    if (pill) {
      var info = pill.closest('[data-product-info]');
      var variants = info && variantData(info);
      if (variants) {
        var optGroup = pill.closest('[data-option-index]');
        $$('[data-option-value]', optGroup).forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var opts = selectedOptions(info);
        var match = variants.find(function (v) {
          return v.options.every(function (val, i) { return opts[i] === val; });
        });
        applyVariant(info, match);
      }
      return;
    }

    var upsellBtn = t.closest && t.closest('[data-upsell-add]');
    if (upsellBtn) {
      upsellBtn.disabled = true;
      upsellBtn.textContent = strings.adding || 'Legger til …';
      var fd = new FormData();
      fd.append('id', upsellBtn.getAttribute('data-variant-id'));
      fd.append('quantity', '1');
      fd.append('properties[__essential_upsell_funnel_id]', upsellBtn.getAttribute('data-funnel-id'));
      addToCart(fd).catch(function () {
        upsellBtn.disabled = false;
        upsellBtn.textContent = strings.add_short || 'Legg til';
      });
      return;
    }

    var buybarAdd = t.closest && t.closest('[data-buybar-add]');
    if (buybarAdd) {
      var mainForm = $('form[data-product-form]');
      if (mainForm) handleProductSubmit(mainForm);
      return;
    }

    /* Primær ATC-knapp er type="button" (ikke submit): et native submit-event mot
       /cart/add-skjemaet får Shopifys instrumentering til å publisere
       product_added_to_cart i tillegg til publiseringen fra selve AJAX-kallet
       (dokumentert i _audit/meta-atc-dedup-evidence-2026-08-27.md). Klikkbanen
       kaller derfor handleren direkte — samme mønster som kjøpelinjen over.
       Submit-lytteren under beholdes som fallback for implisitt skjemainnsending. */
    var addBtn = t.closest && t.closest('[data-add-button]');
    if (addBtn && addBtn.type === 'button' && !addBtn.disabled) {
      var addForm = addBtn.closest('form[data-product-form]');
      if (addForm) handleProductSubmit(addForm);
      return;
    }

    var seed = t.closest && t.closest('[data-search-seed]');
    if (seed) {
      var input = $('[data-search-input]');
      if (input) {
        input.value = seed.getAttribute('data-search-seed');
        input.focus();
        runSearch();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllOverlays(null);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-product-form]');
    if (!form) return;
    var submit = $('[data-add-button]', form);
    if (submit && (submit.disabled || submit.getAttribute('aria-disabled') === 'true')) { e.preventDefault(); return; }
    e.preventDefault();
    handleProductSubmit(form);
  });

  /* ---------- Mobil/nettbrett kjøpelinje ----------
     Hybrid synlighet: CSS viser linjen fra første paint (ingen JS-venting før
     kjøpshandlingen er synlig). JS skjuler den KUN mens hoved-CTA-en er reelt
     synlig og klikkbar i det brukbare feltet mellom den faste headeren og
     feltet linjen selv opptar. Ren geometri — ikke isIntersecting, siden
     knappen kan krysse viewporten og likevel ligge bak header/linje. Linjens
     høyde reserveres i beregningen også mens den er skjult (offsetHeight
     påvirkes ikke av transform), ellers ville tilstanden oscillere.
     Klikket håndteres av klikk-delegatoren over ([data-buybar-add]). */
  var buybarTicking = false;
  function updateBuybar() {
    buybarTicking = false;
    var bar = $('[data-buybar]');
    if (!bar || window.innerWidth > 1023) return;
    var btn = $('[data-add-button]');
    if (!btn) { bar.classList.remove('is-hidden'); return; }
    var r = btn.getBoundingClientRect();
    var header = $('.ll-header');
    /* bottom (= topp-offset + høyde) i stedet for height: med kampanjelinje
       over headeren starter det brukbare feltet under linje + header. Uten
       linje er bottom identisk med height. */
    var headerH = header ? header.getBoundingClientRect().bottom : 64;
    var margin = 8;
    var usable = r.height > 0 &&
      r.top >= headerH + margin &&
      r.bottom <= window.innerHeight - bar.offsetHeight - margin;
    bar.classList.toggle('is-hidden', usable);
  }
  function requestBuybarUpdate() {
    if (buybarTicking) return;
    buybarTicking = true;
    requestAnimationFrame(updateBuybar);
  }
  window.addEventListener('scroll', requestBuybarUpdate, { passive: true });
  window.addEventListener('resize', requestBuybarUpdate, { passive: true });

  /* ---------- Predictive search (input-lytter via delegering) ---------- */
  function hitTemplate(item) {
    var img = item.image ? '<img src="' + item.image + '" alt="" loading="lazy"' + (item.contain ? ' class="contain"' : '') + '>' : '';
    return '<a class="ll-search__hit" href="' + item.url + '">' +
      '<span class="ll-search__hit-img">' + img + '</span>' +
      '<span class="ll-search__hit-body">' +
      '<span class="t-kicker">' + item.kind + '</span>' +
      '<span class="ll-search__hit-title">' + item.title + '</span>' +
      (item.meta ? '<span class="t-body" style="color:var(--ink-62)">' + item.meta + '</span>' : '') +
      '</span><span class="arrow t-meta" aria-hidden="true">&rarr;</span></a>';
  }
  var runSearch = debounce(function () {
    var input = $('[data-search-input]');
    var list = $('[data-search-results]');
    if (!input || !list) return;
    var label = $('[data-search-label]');
    var empty = $('[data-search-empty]');
    var defaults = $('[data-search-defaults]');
    var q = input.value.trim();
    if (!q) {
      list.innerHTML = '';
      if (defaults) defaults.hidden = false;
      if (empty) empty.hidden = true;
      if (label) label.textContent = strings.search_suggestions || 'Utvalgte resultater';
      return;
    }
    var url = (routes.predictive_search_url || '/search/suggest') +
      '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url).then(function (r) { return r.json(); }).then(function (data) {
      if (input.value.trim() !== q) return;
      var res = data.resources.results;
      var items = [];
      (res.products || []).forEach(function (p) {
        /* Gavekortet er kun et kurv-tilbud — aldri i søk */
        var handle = (p.handle || p.url || '').toLowerCase();
        var title = (p.title || '').toLowerCase();
        if (handle.indexOf('gavekort') > -1 || handle.indexOf('gift-card') > -1 || title.indexOf('gavekort') > -1 || title.indexOf('gift card') > -1) return;
        items.push({ kind: strings.search_products || 'Solbriller', title: p.title, meta: p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '', url: p.url, image: p.featured_image && p.featured_image.url, contain: true });
      });
      (res.articles || []).forEach(function (a) {
        items.push({ kind: strings.search_articles || 'Journal', title: a.title, meta: '', url: a.url, image: a.image });
      });
      (res.pages || []).forEach(function (p) {
        items.push({ kind: strings.search_pages || 'Kundeservice', title: p.title, meta: '', url: p.url, image: null });
      });
      if (defaults) defaults.hidden = true;
      if (items.length) {
        list.innerHTML = items.map(hitTemplate).join('');
        if (empty) empty.hidden = true;
        if (label) label.textContent = items.length + ' ' + (strings.search_hits || 'treff');
      } else {
        list.innerHTML = '';
        if (empty) {
          empty.hidden = false;
          var qEl = $('[data-search-query]', empty);
          if (qEl) qEl.textContent = q;
        }
        if (label) label.textContent = '0 ' + (strings.search_hits || 'treff');
      }
    }).catch(function () {});
  }, 220);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-search-input]')) runSearch();
  });

  /* ---------- Sideoverganger (progressiv forbedring) ---------- */
  (function () {
    if (reduced || designMode) return;
    var veil = $('[data-ll-veil]');
    if (!veil) return;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.getAttribute('href').charAt(0) === '#') return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;
      if (/\/(checkout|cart\/c\/|account|password)/.test(url.pathname)) return;
      e.preventDefault();
      veil.classList.add('is-active');
      window.setTimeout(function () { window.location.href = a.href; }, 230);
    });
    window.addEventListener('pageshow', function () {
      veil.classList.remove('is-active');
    });
  })();

  /* ---------- Høstkampanje: nedtelling (kun sluttfase, ekte sluttid) ---------- */
  (function () {
    var el = $('[data-camp-countdown]');
    if (!el) return;
    var end = parseInt(el.getAttribute('data-camp-end'), 10) * 1000;
    var units = (el.getAttribute('data-camp-units') || 'd|t|min').split('|');
    if (!end) return;
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) {
        /* kampanjeslutt: fjern linjen helt (aldri en teller på null) */
        var bar = el.closest('.ll-camp-bar');
        if (bar) bar.remove();
        document.body.classList.remove('has-camp-bar');
        return;
      }
      var m = Math.floor(ms / 60000);
      el.textContent = Math.floor(m / 1440) + ' ' + units[0] + ' ' + Math.floor(m % 1440 / 60) + ' ' + units[1] + ' ' + m % 60 + ' ' + units[2];
      setTimeout(tick, 30000);
    }
    tick();
  })();

  /* ---------- Høstkampanje: popup-prototype (av som standard i settings).
       Trigges aldri ved sidelast: desktop = exit intent, mobil = reelt
       engasjement (scroll + tid). Én visning per økt. ---------- */
  (function () {
    var pop = $('[data-camp-popup]');
    if (!pop) return;
    var shown = false;
    try { shown = sessionStorage.getItem('ll-camp-pop') === '1'; } catch (e) { }
    function open() {
      if (shown) return;
      shown = true;
      try { sessionStorage.setItem('ll-camp-pop', '1'); } catch (e) { }
      pop.hidden = false;
      var c = $('[data-camp-popup-close]', pop);
      if (c) c.focus();
    }
    pop.addEventListener('click', function (e) {
      if (e.target === pop || e.target.closest('[data-camp-popup-close]')) pop.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) pop.hidden = true;
    });
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 8) open();
      });
    } else {
      var t0 = Date.now();
      window.addEventListener('scroll', function onS() {
        if (window.scrollY > 1200 && Date.now() - t0 > 15000) {
          window.removeEventListener('scroll', onS);
          open();
        }
      }, { passive: true });
    }
  })();

  /* ---------- Klaviyo nyhetsbrevtransport ----------
     Delt av popup, forside og footer. Bruker kun offentlig site-ID og
     Klaviyos Client Subscription API; private nøkler finnes aldri i temaet. */
  var KLAVIYO_REVISION = '2025-10-15';
  function createKlaviyoSubscription(opts) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(opts.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: opts.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: opts.email,
                  properties: { signup_locale: opts.locale, signup_offer: opts.offer || 'none' },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: opts.list } } }
        }
      })
    });
  }

  /* ---------- Nyhetsbrev-popup ----------
     Rendres server-side kun når den er på (theme.liquid). Åpnes straks etter
     ferdig cookievalg, aldri over andre modaler. Vises én gang per faneøkt,
     også til tidligere kunder og abonnenter. Kun visningstilstand lagres i
     sessionStorage — aldri e-post/telefon. Aktivt, uavkrysset samtykke kreves
     før innsending til Klaviyo. Kun anonyme dataLayer-hendelser. */
  (function () {
    var pop = $('[data-nl-popup]');
    if (!pop) return;
    /* Backstop (server-gaten i theme.liquid er primær): avbryt HELE
       popup-initialiseringen på Shopifys captcha-/challenge-/verifiserings-
       sider — gjelder også QA-tvangsbryteren. */
    if (/template-(captcha|challenge)/.test(document.body.className) ||
        document.querySelector('.shopify-challenge__container, form[action$="/challenge"]') ||
        /\/challenge$/.test(window.location.pathname)) {
      pop.remove();
      return;
    }
    /* Vis til alle, også tidligere abonnenter, én gang per faneøkt.
       Gamle langvarige localStorage-flagg (ll-nl-done / ll-nl-dismissed)
       påvirker ikke lenger visningen. */
    var KEY_SEEN = 'll-nl-seen-session-v2';
    var force = pop.getAttribute('data-nl-force') === '1';
    function sessionSeen() {
      try { return sessionStorage.getItem(KEY_SEEN) === '1'; } catch (e) { return false; }
    }
    function markSessionSeen() {
      try { sessionStorage.setItem(KEY_SEEN, '1'); } catch (e) { }
    }
    if (!force && sessionSeen()) return;
    var opened = false, releaseTrap = null, lastFocus = null, guardTimer = null;
    function otherModalOpen() {
      var camp = $('[data-camp-popup]');
      return !!($('.ll-cart.is-open') || $('.ll-menu.is-open') || $('.ll-search.is-open') || $('.ll-locale.is-open') || (camp && !camp.hidden));
    }
    /* Cookie-/personvern-UI (Shopify Customer Privacy) har ALLTID prioritet.
       «Avklart» betyr at brukeren har tatt et valg — aksept, avvisning eller
       egne preferanser er alle likeverdige. Marketing-samtykke kreves ALDRI
       for nyhetsbrevpopupen; kun at valget er tatt og UI-et lukket. */
    function privacyUiVisible() {
      var b = document.getElementById('shopify-pc__banner');
      var p = document.getElementById('shopify-pc__prefs');
      function vis(el) { return !!el && el.getBoundingClientRect().height > 0; }
      return vis(b) || vis(p);
    }
    /* Har besøkende faktisk tatt et samtykkevalg? currentVisitorConsent()
       gir 'yes'/'no' per kategori når valget er tatt, og tomme strenger før.
       Dette er den primære sannhetskilden: shouldShowBanner() fortsetter å
       rapportere true for regioner som krever banner, også etter at valget
       er tatt, og kan derfor ikke alene avgjøre om popupen får starte. */
    function privacyChoiceMade() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.currentVisitorConsent === 'function') {
          var c = cp.currentVisitorConsent() || {};
          var kat = [c.marketing, c.analytics, c.preferences];
          for (var i = 0; i < kat.length; i++) {
            if (kat[i] === 'yes' || kat[i] === 'no') return true;
          }
        }
      } catch (e) { }
      return false;
    }
    function privacyResolved() {
      /* Sikkerhetsnett: aldri åpne mens banner-/preferanse-UI er synlig. */
      if (privacyUiVisible()) return false;
      if (privacyChoiceMade()) return true;
      /* Intet valg ennå: regionen avgjør om vi må vente. */
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) return false;
      } catch (e) { }
      return true;
    }
    /* Anonyme popup-hendelser respekterer samtykkearkitekturen: har brukeren
       avvist analyse-kategorien, sendes ingenting. */
    function track(ev) {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.currentVisitorConsent === 'function') {
          var c = cp.currentVisitorConsent();
          if (c && c.analytics === 'no') return;
        } else {
          /* API-et er ikke alltid lastet — fall tilbake til Shopifys
             _tracking_consent-cookie: "a":"0" = analyse avvist. */
          var m = document.cookie.match(/_tracking_consent=([^;]+)/);
          if (m && /%22a%22%3A%220%22|"a":"0"/.test(decodeURIComponent(m[1]))) return;
        }
      } catch (e) { }
      if (window.dataLayer) window.dataLayer.push({ event: ev });
    }
    /* Bildet lastes når triggerklokken starter (etter samtykkevalget), så det
       er klart før modalen vises — aldri et tomt bildefelt. */
    function primeImage() {
      var img = $('img[data-nl-src]', pop);
      if (img && !img.getAttribute('src')) {
        var ss = img.getAttribute('data-nl-srcset');
        if (ss) img.srcset = ss;
        img.src = img.getAttribute('data-nl-src');
      }
      return img;
    }
    function open() {
      if (opened || otherModalOpen() || !privacyResolved()) return;
      opened = true;
      var img = primeImage();
      if (img && !(img.complete && img.naturalWidth > 0)) {
        var revealed = false;
        var go = function () {
          if (revealed) return;
          revealed = true;
          /* Situasjonen kan ha endret seg mens bildet lastet. */
          if (otherModalOpen() || !privacyResolved()) { opened = false; scheduleRetry(250); return; }
          reveal();
        };
        img.addEventListener('load', go, { once: true });
        img.addEventListener('error', go, { once: true });
        window.setTimeout(go, 1200);
        return;
      }
      reveal();
    }
    function reveal() {
      markSessionSeen();
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      releaseTrap = trapFocus(pop);
      var panel = $('.ll-nl-popup__panel', pop);
      if (panel) panel.focus();
      track('newsletter_popup_view');
      /* Vakt mot modalkollisjon: åpner kurv/meny/søk seg (f.eks. drawer etter
         et add-to-cart som var i flukt før popupen åpnet), viker popupen —
         uten å telle som avvisning. */
      guardTimer = window.setInterval(function () {
        if (!pop.hidden && (otherModalOpen() || privacyUiVisible())) close(false);
      }, 250);
    }
    function close(dismiss) {
      /* Animert lukking i sidens bevegelsesspråk: fade + liten senkning,
         deretter skjules elementet og fokus/scroll-lås gjenopprettes. */
      if (pop.hidden || pop.classList.contains('is-closing')) return;
      pop.classList.add('is-closing');
      pop.classList.remove('is-open');
      if (guardTimer) { window.clearInterval(guardTimer); guardTimer = null; }
      if (dismiss) track('newsletter_popup_close');
      window.setTimeout(function () {
        pop.classList.remove('is-closing');
        pop.hidden = true;
        pop.style.paddingTop = '';
        pop.style.alignItems = '';
        document.body.style.overflow = '';
        if (releaseTrap) { releaseTrap(); releaseTrap = null; }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, reduced ? 90 : 310);
    }
    pop.addEventListener('click', function (e) {
      if (e.target === pop || (e.target.closest && e.target.closest('[data-nl-close]'))) close(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) close(true);
    });
    /* Åpnes straks cookievalget er avklart og cookie-vinduet er lukket —
       ingen ekstra timer, scrollterskel eller pause etter valget. Har
       besøkende et tidligere cookievalg, åpnes den ved inngang så snart
       personvernstatus er klar. Kurv, meny, søk, språkvelger og
       kampanje-popup har prioritet; da prøves det igjen like etter. */
    var retryTimer = null;
    function scheduleRetry(ms) {
      if (retryTimer) window.clearTimeout(retryTimer);
      retryTimer = window.setTimeout(function () { retryTimer = null; tryOpen(); }, ms || 250);
    }
    function tryOpen() {
      if (opened) return;
      if (!privacyResolved() || otherModalOpen()) { scheduleRetry(250); return; }
      open();
    }
    /* Hendelsen kan komme før banneret er animert bort — tryOpen venter
       selv til UI-et faktisk er lukket. */
    document.addEventListener('visitorConsentCollected', function () { scheduleRetry(50); });
    function privacyApiReady() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.currentVisitorConsent === 'function' && typeof cp.shouldShowBanner === 'function');
    }
    /* Vent kort på personvern-API-et (maks 5 s) slik at popupen aldri
       havner over et cookiebanner som lastes sent. */
    var bootStart = Date.now();
    (function boot() {
      if (force || privacyApiReady() || Date.now() - bootStart > 5000) {
        primeImage();
        tryOpen();
        return;
      }
      window.setTimeout(boot, 100);
    })();
    /* Suksessovergang (kjøres nøyaktig én gang): fra skjematilstand til den
       doble opt-in-bekreftelsen «Nesten i mål» — trigges direkte av 202 fra
       Klaviyo, helt uten sidenavigasjon. */
    var slid = false;
    function runSuccessSlide() {
      if (slid) return;
      /* Glidningen skal ses: venter til modalen faktisk er åpen (f.eks. hvis
         cookievalget først må avklares etter returen). */
      if (pop.hidden) { window.setTimeout(runSuccessSlide, 500); return; }
      slid = true;
      var vp = $('[data-nl-viewport]', pop);
      var fv = $('[data-nl-form-view]', pop);
      var sv = $('[data-nl-success-view]', pop);
      if (!vp || !fv || !sv) return;
      function settle() {
        fv.hidden = true;
        fv.removeAttribute('inert');
        sv.removeAttribute('aria-hidden');
        vp.classList.remove('is-sliding');
      }
      if (reduced) {
        /* Redusert bevegelse: kort ren crossfade — ingen sideveis reise/blur */
        fv.style.transition = 'opacity 120ms linear';
        fv.style.opacity = '0';
        window.setTimeout(function () {
          settle();
          sv.hidden = false;
          sv.style.opacity = '0';
          sv.style.transition = 'opacity 120ms linear';
          requestAnimationFrame(function () { sv.style.opacity = '1'; });
        }, 130);
        return;
      }
      /* Ekte spor-glidning: suksess-sliden gjøres synlig i posisjonen rett til
         høyre for skjemaet, og hele sporet glir én panelbredde mot venstre i
         ÉN bevegelse — panelet er aldri tomt, og opacity røres ikke.
         Skjermlesere ser aldri begge tilstandene: utgående skjema er
         inert/aria-hidden fra start; suksessen annonseres når den lander.
         Viewporthøyden låses så modalskallet står helt i ro. */
      /* Desktop: viewporten har konstant fylt høyde og suksessen ligger
         permanent på samme sentrerte, absolutte flate — settle endrer ingen
         computed layout (roten til slutt-snappet). Mobil: høyden låses under
         animasjonen; innholdet er topp-justert, så den myke høydeglidningen
         etterpå flytter ingenting synlig. */
      var mobil = window.innerWidth < 768;
      if (mobil) vp.style.height = fv.offsetHeight + 'px';
      fv.setAttribute('inert', '');
      fv.setAttribute('aria-hidden', 'true');
      sv.setAttribute('aria-hidden', 'true');
      sv.hidden = false;
      vp.classList.add('is-sliding');
      var settled = false;
      var commit = function () {
        if (settled) return;
        settled = true;
        /* animationend → la siste ramme males, fjern så klassene i en
           tilstand der hvile-CSS-en er identisk med sluttrammen */
        requestAnimationFrame(function () {
          fv.hidden = true;
          requestAnimationFrame(function () {
            settle();
            if (mobil) {
              /* Anker panelets TOPP før høydeglidningen: containeren sentrerer
                 normalt panelet, så en krympende høyde ville flyttet alt
                 innhold nedover. Med toppen låst står teksten bom stille og
                 kun den tomme flaten under trekker seg sammen. Nullstilles
                 ved lukking. */
              var panelEl = $('.ll-nl-popup__panel', pop);
              if (panelEl) {
                pop.style.paddingTop = panelEl.getBoundingClientRect().top + 'px';
                pop.style.alignItems = 'flex-start';
              }
              var mål = sv.offsetHeight;
              vp.style.transition = 'height 320ms var(--ease)';
              vp.style.height = mål + 'px';
              window.setTimeout(function () { vp.style.transition = ''; vp.style.height = ''; }, 360);
            }
          });
        });
      };
      sv.addEventListener('animationend', commit, { once: true });
      window.setTimeout(commit, 900); /* sikkerhetsnett hvis eventet uteblir */
    }
    /* ---------- Innsending: Klaviyo Create Client Subscription ----------
       Offisiell nettleser-API med offentlig site-ID (aldri privat nøkkel).
       Alt skjer i modalen via fetch: ingen sidenavigasjon, ingen Shopify
       /challenge. 202 betyr «mottatt» — listens doble opt-in avgjør endelig
       påmelding, derfor sier suksessvisningen «Nesten i mål». Ved feil blir
       skjemaet stående med rolig inline-melding; vi faller ALDRI stille
       tilbake til Shopify-POST. */
    var form = $('[data-nl-form]', pop);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var status = $('[data-nl-status]', pop);
      var email = $('#NlPopupEmail', pop);
      var consent = $('[data-nl-consent]', pop);
      function fail(msg) { if (status) { status.hidden = false; status.textContent = msg; } }
      if (status) status.hidden = true;
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) { fail(strings.nl_error_email || 'Skriv inn en gyldig e-postadresse.'); return; }
      if (!consent || !consent.checked) { fail(strings.nl_error_consent || 'Huk av for samtykke for å melde deg på.'); return; }
      /* Valgfritt telefonfelt: valideres kun hvis utfylt — blokkerer aldri
         e-postpåmeldingen, og sendes IKKE i produksjons-payloaden (SMS
         konfigureres separat i Klaviyo senere). */
      var tlf = $('[data-nl-phone]', form);
      if (tlf && tlf.value.trim() !== '' && !/^\d{6,12}$/.test(tlf.value.replace(/[\s-]/g, ''))) {
        fail(strings.nl_error_phone || 'Skriv inn et gyldig telefonnummer, eller la feltet stå tomt.');
        return;
      }
      var company = pop.getAttribute('data-nl-klaviyo-company');
      var list = pop.getAttribute('data-nl-klaviyo-list');
      var locale = pop.getAttribute('data-nl-locale') || '';
      if (!company || !list) { fail(strings.nl_error || 'Det oppstod en feil. Prøv igjen.'); return; }
      if (form.dataset.sending === '1') return;
      form.dataset.sending = '1';
      var btn = $('[data-nl-submit]', form);
      var orig = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.classList.add('is-submitting');
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = strings.adding || '…';
      }
      function reset() {
        delete form.dataset.sending;
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-submitting');
          btn.removeAttribute('aria-busy');
          btn.textContent = orig;
        }
      }
      track('newsletter_popup_submit');
      createKlaviyoSubscription({
        company: company,
        list: list,
        email: email.value.trim(),
        locale: locale,
        source: 'Luca & Luce nyhetsbrev-popup',
        offer: pop.getAttribute('data-nl-offer') || 'none'
      }).then(function (r) {
        if (r.ok || r.status === 202) {
          /* Samme nøytrale tilstand for nye og allerede kjente profiler —
             ingen kontoenumerering. Visningen er registrert for faneøkten;
             e-postadressen lagres aldri i nettleseren. */
          delete form.dataset.sending;
          markSessionSeen();
          track('newsletter_popup_success');
          runSuccessSlide();
          return;
        }
        if (r.status === 429) {
          var vent = parseInt(r.headers.get('Retry-After'), 10);
          reset();
          fail(strings.nl_error_rate || 'Det gikk litt fort. Vent et øyeblikk og prøv igjen.');
          if (btn && vent > 0) {
            btn.disabled = true;
            window.setTimeout(function () { btn.disabled = false; }, Math.min(vent, 60) * 1000);
          }
          return;
        }
        return r.json().catch(function () { return null; }).then(function (j) {
          reset();
          var detalj = j && j.errors && j.errors[0] && ((j.errors[0].detail || '') + (j.errors[0].title || ''));
          if (detalj && /email/i.test(detalj)) fail(strings.nl_error_email || 'Skriv inn en gyldig e-postadresse.');
          else fail(strings.nl_error || 'Det oppstod en feil. Prøv igjen.');
        });
      }).catch(function () {
        /* KUN det moderne, offisielle client-API-et er godkjent transport:
           det er bevist å utløse dobbel opt-in korrekt. Legacy-endepunktet
           (manage.kmail-lists.com) er FJERNET permanent — det abonnerte
           profiler direkte og omgikk dobbel opt-in. Ved nettverks-/CORS-feil
           blir brukeren stående i skjemaet med ærlig feilmelding; vi viser
           ALDRI «Nesten i mål» uten et ekte 202 fra Klaviyo, og vi faller
           aldri tilbake til Shopify /contact. */
        reset();
        fail(strings.nl_error || 'Det oppstod en feil. Prøv igjen.');
      });
    });
  })();

  /* ---------- Nyhetsbrevskjema på forside og i footer ---------- */
  function initInlineNewsletters(scope) {
    $$('[data-nl-inline-form]', scope).forEach(function (form) {
      if (form.dataset.nlBound === '1') return;
      form.dataset.nlBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = $('[data-nl-inline-email]', form);
        var consent = $('[data-nl-inline-consent]', form);
        var status = $('[data-nl-inline-status]', form);
        var btn = $('[data-nl-inline-submit]', form);
        function show(msg, ok) {
          if (!status) return;
          status.hidden = false;
          status.textContent = msg;
          status.classList.toggle('ll-form-status--ok', !!ok);
          status.classList.toggle('ll-form-status--error', !ok);
        }
        if (status) status.hidden = true;
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
          show(strings.nl_error_email || 'Skriv inn en gyldig e-postadresse.', false);
          return;
        }
        if (!consent || !consent.checked) {
          show(strings.nl_error_consent || 'Huk av for samtykke for å melde deg på.', false);
          return;
        }
        var company = form.getAttribute('data-nl-klaviyo-company');
        var list = form.getAttribute('data-nl-klaviyo-list');
        if (!company || !list || form.dataset.sending === '1') {
          if (!company || !list) show(strings.nl_error || 'Det oppstod en feil. Prøv igjen.', false);
          return;
        }
        form.dataset.sending = '1';
        var original = btn ? btn.textContent : '';
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          btn.textContent = strings.adding || '…';
        }
        function reset() {
          delete form.dataset.sending;
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.textContent = original;
          }
        }
        createKlaviyoSubscription({
          company: company,
          list: list,
          email: email.value.trim(),
          locale: form.getAttribute('data-nl-locale') || '',
          source: form.getAttribute('data-nl-source') || 'Luca & Luce nyhetsbrev',
          offer: 'none'
        }).then(function (r) {
          if (r.ok || r.status === 202) {
            delete form.dataset.sending;
            form.classList.add('is-complete');
            $$('input, button', form).forEach(function (el) { el.disabled = true; });
            show(strings.nl_success || 'Vi har sendt deg en e-post. Bekreft påmeldingen der, så er du med.', true);
            return;
          }
          if (r.status === 429) {
            reset();
            show(strings.nl_error_rate || 'Det gikk litt fort. Vent et øyeblikk og prøv igjen.', false);
            return;
          }
          return r.json().catch(function () { return null; }).then(function (j) {
            reset();
            var detail = j && j.errors && j.errors[0] && ((j.errors[0].detail || '') + (j.errors[0].title || ''));
            show(detail && /email/i.test(detail) ? (strings.nl_error_email || 'Skriv inn en gyldig e-postadresse.') : (strings.nl_error || 'Det oppstod en feil. Prøv igjen.'), false);
          });
        }).catch(function () {
          reset();
          show(strings.nl_error || 'Det oppstod en feil. Prøv igjen.', false);
        });
      });
    });
  }

  /* ---------- Footer-accordion (kun mobil) ----------
     Lenkegruppene i footeren starter lukket på mobil og åpnes ved trykk på
     overskriften. På desktop (≥768px) overstyrer CSS [hidden] til alltid å
     vise innholdet, uavhengig av denne tilstanden — ren CSS-fallback uten
     JS-avhengighet der. */
  function bindFooterAccordion(scope) {
    $$('[data-footer-toggle]', scope).forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });
  }

  /* ---------- Init (kjøres ved last og per seksjon i editoren) ---------- */
  function initScope(scope) {
    initReveals(scope);
    refreshMotionRefs();
    updateBuybar();
    applyHeader();
    applyMotion();
    initInlineNewsletters(scope);
    bindFooterAccordion(scope);
  }
  initScope(document);

  /* ---------- Theme Editor-livssyklus ----------
     Editoren rerendrer seksjonens DOM ved hver innstillingsendring.
     Reveals, motion-referanser og observere reinitialiseres for den
     nye DOM-en, så tekst og innhold alltid forblir synlig. */
  if (designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initScope(e.target);
    });
    document.addEventListener('shopify:section:reorder', function () {
      initScope(document);
    });
    document.addEventListener('shopify:section:select', function (e) {
      initScope(e.target);
    });
    document.addEventListener('shopify:block:select', function (e) {
      initScope(e.target.closest('.shopify-section') || document);
    });
  }
})();
